var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone receiver silhouette",
    clipPath: "url(#clip0_579_668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5753 27.3681C13.0557 27.0524 15.0805 26.2853 15.1394 23.8048L15.1658 22.3157C15.1893 21.23 13.7494 17.8659 22.7323 18.055C31.7079 18.2393 30.1329 21.5455 30.1041 22.628L30.0744 24.1224C30.0249 26.5981 32.0149 27.4518 34.4808 27.8702L35.9723 28.126C38.4387 28.5366 40.4512 28.3732 40.5059 25.8956L40.5307 24.5526C40.6401 23.5348 40.7426 20.5056 38.3626 17.5897C35.5082 14.0894 30.2894 12.2314 22.8551 12.0762C15.4231 11.9148 10.129 13.5548 7.12895 16.9358C4.63546 19.7453 4.6045 22.7798 4.67067 23.7976L4.64425 25.1442C4.59198 27.6174 6.59517 27.8682 9.07918 27.554L10.5753 27.3681Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_579_668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.4556,
    height: 31.4556,
    fill: "white",
    transform: "translate(45 22) rotate(132.207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCancel);
export default __webpack_public_path__ + "static/media/phone-cancel.7f1abb6b43ea2405e73fc9f6e60c39f5.svg";
export { ForwardRef as ReactComponent };